import OktaAuth, { AccessToken } from '@okta/okta-auth-js';
import { OKTA_CLIENT_ID, OKTA_ISSUER } from './constants';

export const oktaAuth = new OktaAuth({
    issuer: OKTA_ISSUER,
    clientId: OKTA_CLIENT_ID,
    redirectUri: window.location.origin + '/login/callback',
    tokenManager: {
        autoRenew: true,
    },
});

export const getAccessToken = async (): Promise<AccessToken | undefined> => {
    await oktaAuth.authStateManager.updateAuthState();
    return oktaAuth.authStateManager.getAuthState()?.accessToken;
};

export const signOut = () => {
    oktaAuth.signOut();
};
